export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';
export const GET_ROBOTS_PENDING = 'GET_ROBOTS_PENDING';
export const GET_ROBOTS_SUCCESS = 'GET_ROBOTS_SUCCESS';
export const GET_ROBOTS_FAILED = 'GET_ROBOTS_FAILED';